import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Jumbotron/Jumbotron';

class Jumbotron extends React.Component {
  render() {
    return (
      <header>
        <div className={'header-content ' + this.props.loadAnimation}>
          <div
            className={
              'header-content-inner ' + this.props.actionAnimation || ''
            }
          >
            <InlineEditableElement
              size={this.props.size}
              fontFamilyChanged={this.props.fontFamilyChanged.bind(this)}
              style={{maxWidth: '100%'}}
              el="div"
              onChange={this.props.valueChanged.bind(this)}
              html={this.props.section.prop('content')}
              inlineEditingEnabled={this.props.inlineEditingEnabled}
            />
          </div>
        </div>
      </header>
    );
  }
}

export default hoc(Jumbotron);
